<template>
  <div class="main-content single-rule">
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
          <el-form-item v-show="tabIndex === '0'" style="margin-right:50px;" :label="$t('AutomaticRelease.selectBranch')">
            <el-select v-model="branchId" @change="changeOfficeHandler">
              <el-option
                v-for="(item, index) in branchList"
                :key="index"
                :label="item.code"
                :value="item.officeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span>{{ $t('CargoMsg.Cargo_Search') }}</span>
            <el-input
              v-model="ruleName"
              :placeholder="$t('AutomaticRelease.enterRuleName')"
              style="width:200px;margin: 0 12px"
              @input="getList()"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button type="primary" @click="add">{{ $t('AutomaticRelease.add') }}</el-button>
        <el-button :disabled="Object.keys(selectedRows).length === 0" type="primary" @click="editor">{{ $t('AutomaticRelease.edit') }}</el-button>
        <el-button :disabled="Object.keys(selectedRows).length === 0" size="mini" type="danger" @click="remove">{{ $t('AutomaticRelease.deletes') }}</el-button>
        <el-button type="primary" @click="refresh">{{ $t('AutomaticRelease.refresh') }}</el-button>
      </div>
    </div>
    <div class="section" style="flex:1;">
      <cargo-ag-grid
        v-show="tabIndex === '0'"
        :wrap-text="true"
        :config-module="configModule"
        :grid-options="combinatioGridOptions"
        :column-defs="combinationColumnDefs"
        :row-data="combinationRowData"
        @gridReady="combinatioGridReady"
      />
      <cargo-ag-grid
        v-show="tabIndex === '1'"
        :config-module="configModule"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <rules-Combination
      ref="rulesCombination"
      :is-show="isShow"
      :branch-list="branchList"
      :tab-index="tabIndex"
      :selected-rows="selectedRows"
      @cancel="cancel"
      @getList="getList"
    />
    <dialog-Rule
      ref="dialogRule"
      :is-show="isShow"
      :branch-list="branchList"
      :tab-index="tabIndex"
      :selected-rows="selectedRows"
      @cancel="cancel"
      @getList="getList"
    />
  </div>
</template>
<script>
import { cacheName, cache } from '@/utils/cacheManager'
import rulesCombination from '@/components/Cargo/Common/SingleRule/AddSingleRuleDialog/rulesCombination'
import dialogRule from '@/components/Cargo/Common/SingleRule/AddSingleRuleDialog/dialogRule'
import { getLoading } from '@/utils/utilBaseElement'
import {
  releaseDocRuleList,
  batchDelReleaseDocRule,
  batchDelReleaseDocRuleGroup,
  releaseDocRuleGroupList,
  batchUpdateReleaseDocRuleGroup
} from '@/api/sysManage/baseConfig/putASingleRule'
export default {
  name: 'SingleRule',
  components: { rulesCombination, dialogRule },
  props: {
    tabIndex: {
      type: String,
      default: '0'
    },
    configModule: {
      type: String,
      default: '2022072501'
    }
  },
  data() {
    return {
      loading: false,
      rowDrag: true,
      branchId: 0,
      ruleName: '',
      isShow: false,
      branchList: [],
      rowsList: [],
      selectedRows: {},
      rowData: [],
      combinationRowData: [],
      conversionType: {
        'releaseDocRuleDataVo.docType': this.$t('AutomaticRelease.common.docType'),
        'releaseDocRuleDataVo.customerSelfRelease': this.$t('AutomaticRelease.common.customerSelfRelease'),
        'releaseDocRuleDataVo.releaseType': this.$t('AutomaticRelease.common.releaseType'),
        'releaseDocRuleDataVo.cargoSource': this.$t('AutomaticRelease.common.cargoSource'),
        'releaseDocRuleDataVo.customerType': this.$t('AutomaticRelease.common.customerType')
      },
      conversionRules: {
        'releaseDocRuleDataVo.creditObject': this.$t('AutomaticRelease.common.creditObject'),
        'releaseDocRuleDataVo.receivableType': this.$t('AutomaticRelease.common.receivableType'),
        'releaseDocRuleDataVo.creditLimitedDate': this.$t('AutomaticRelease.common.creditLimitedDate'),
        'releaseDocRuleDataVo.creditLimitAmount': this.$t('AutomaticRelease.common.creditLimitAmount')
      },
      columnDefs: [
        {
          headerName: this.$t('AutomaticRelease.ruleName'),
          field: 'ruleName',
          width: 150
        },
        {
          headerName: this.$t('AutomaticRelease.businessTypes'),
          field: 'businessTypes',
          width: 150
        },
        {
          headerName: this.$t('AutomaticRelease.conversionRules'),
          field: 'conversionRules',
          width: 150
        },
        {
          headerName: this.$t('AutomaticRelease.ruleDescription'),
          field: 'ruleDescription',
          width: 150
        }
      ],
      combinatioGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        suppressContextMenu: true, // 右键列表弹出菜单
        gridApi: null,
        onRowDragEnd: this.refreshList,
        onRowClicked: (params) => {
          this.selectedRows = params.data
        }
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        suppressContextMenu: true, // 右键列表弹出菜单
        onRowClicked: (params) => {
          this.selectedRows = params.data
        }
      }
    }
  },
  computed: {
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    combinationColumnDefs() {
      const combinationColumnDefs = [
        {
          headerName: this.$t('AutomaticRelease.orderNum'),
          field: 'orderNum',
          width: 120,
          rowDrag: this.rowDrag,
          sortable: true,
          suppressMenu: true,
          rowDragEntireRow: true,
          suppressSizeToFit: true,
          lockVisible: true,
          initialHide: false
        },
        {
          headerName: this.$t('AutomaticRelease.ruleGroupName'),
          field: 'ruleGroupName',
          width: 150
        },
        {
          headerName: this.$t('AutomaticRelease.ruleNames'),
          field: 'ruleNames',
          width: 300
        },
        {
          headerName: this.$t('AutomaticRelease.performActions'),
          field: 'performActions',
          width: 350
        },
        {
          headerName: this.$t('AutomaticRelease.officeCode'),
          field: 'officeCode',
          width: 300
        },
        {
          headerName: this.$t('AutomaticRelease.customerCompany'),
          field: 'customerCompany',
          width: 150
        }
      ]
      return combinationColumnDefs
    }
  },
  watch: {
    branchId(value) {
      if (value !== 0 || this.ruleName !== '') {
        this.rowDrag = false
      } else {
        this.rowDrag = true
      }
    },
    ruleName(value) {
      if (value !== '' || this.branchId !== 0) {
        this.rowDrag = false
      } else {
        this.rowDrag = true
      }
    }
  },
  mounted() {
    this.getRulesList()
    this.getCompositionRulesList()
    this.prepareData()// 获取分公司下拉框数据
  },
  methods: {
    // 检索
    getList(refresh) {
      if (this.tabIndex === '0') {
        this.getCompositionRulesList(refresh)
      } else {
        this.getRulesList(refresh)
      }
    },
    // 获取非组合列表
    async getRulesList(refresh) {
      const data = {
        ruleName: this.ruleName.trim()
      }
      const res = await releaseDocRuleList(data)
      if (res) {
        res.data.forEach((item, index) => {
          item.businessTypes = [...new Set(this.conversionFunc(item, 1, 2, 'conversionType'))]
          item.conversionRules = [...new Set(this.conversionFunc(item, 3, 4, 'conversionRules'))]
          if (item.conversionRules.length === 0) {
            item.conversionRules = this.$t('Message.PaymentUponReceipt')
          }
        })

        this.rowData = res.data
        if (refresh === 'refresh') {
          this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
        }
      }
    },
    // 获取组合列表
    async getCompositionRulesList(refresh) {
      const data = {
        groupName: this.ruleName.trim(),
        officeId: this.branchId
      }
      const res = await releaseDocRuleGroupList(data).finally(() => {
        if (this.loading) {
          this.loading.close()
        }
      })
      if (res.ok) {
        res.data.forEach((item) => {
          !item.officeCode ? item.officeCode = this.$t('AutomaticRelease.whole') : item.officeCode
        })
        this.combinationRowData = res.data
        if (refresh === 'refresh') {
          this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
        }
      }
    },
    // 转换业务类型和处理规则
    conversionFunc(data, type1, type2, key) {
      return data.releaseDocMatchConditionVoList.map((item) => {
        // conditionType为1或者2为业务类型
        if (item.matchField && item.conditionType === type1 || item.conditionType === type2) {
          return this[key][item.matchField]
        }
      }).filter(p => typeof p === 'string')
    },
    // 新增
    add() {
      this.isShow = true
      if (this.tabIndex === '0') {
        this.$refs.rulesCombination.getRulesList('add')
      }
    },
    // 编辑
    editor() {
      this.isShow = true
      if (this.tabIndex === '0') {
        this.$refs.rulesCombination.onShow(this.selectedRows)
      }
      if (this.tabIndex === '1') {
        this.$refs.dialogRule.onShow(this.selectedRows)
      }
      this.selectedRows = {}
    },
    // 删除
    async remove() {
      const uuidList = [this.selectedRows.uuid]
      let res = null
      if (this.tabIndex === '0') {
        res = await batchDelReleaseDocRuleGroup(uuidList)
      } else {
        res = await batchDelReleaseDocRule(uuidList)
      }
      if (res.ok) {
        this.getList()
        this.$message.success(this.$t('AutomaticRelease.operationSuccess'))
        this.selectedRows = {}
      }
    },
    // 刷新
    refresh() {
      this.ruleName = ''
      this.branchId = 0
      this.getList('refresh')
    },
    // 关闭弹窗
    cancel(value) {
      this.isShow = value
    },
    // 分公司值变动
    changeOfficeHandler() {
      this.getCompositionRulesList()
    },
    // 更新列表顺序
    async dragUpdate(uuidList) {
      const res = await batchUpdateReleaseDocRuleGroup(uuidList)
      if (res.ok) {
        await this.getCompositionRulesList()
      } else {
        this.loading.close()
      }
    },
    async refreshList() {
      this.loading = getLoading()
      let length = JSON.parse(JSON.stringify(this.combinationRowData.length))
      const uuidList = []
      if (this.combinatioGridOptions.gridApi) {
        this.combinatioGridOptions.gridApi.forEachNode(node => {
          const charge = node.data
          if (this.tabIndex === '0') {
            charge.orderNum = length--
          }
          uuidList.push({
            uuid: charge.uuid,
            orderNum: charge.orderNum,
            version: charge.version,
            ruleGroupName: charge.ruleGroupName,
            officeId: charge.officeId,
            conditionType: charge.conditionType,
            groupDescription: charge.groupDescription,
            behaviorStateAccountReceivable: charge.behaviorStateAccountReceivable,
            behaviorStateRelease: charge.behaviorStateRelease
          })
        })
        await this.combinatioGridOptions.gridApi.refreshCells({ force: true }) // 刷新
        await this.dragUpdate(uuidList)
      }
    },
    combinatioGridReady(params) {
      this.combinatioGridOptions.gridApi = params.api
    },
    // 获取分公司
    async prepareData() {
      await cache.load(cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.branchList = cache.officeList
      this.branchList.unshift({
        code: this.$t('AutomaticRelease.whole'),
        chineseName: this.$t('AutomaticRelease.whole'),
        officeId: 0
      })
    }
  }
}
</script>
<style lang="scss">
.single-rule{
  .cargo-ag-grid .ag-theme-balham .ag-cell-wrapper{
    white-space: normal;
  }
}
</style>
